import { defineComponent } from 'vue';

var script = defineComponent({
    name: 'TransitionDownUp',
    props: {
        blur: {
            type: Boolean,
            default: false,
        },
    },
});

export { script as default };
